<template>
  <a-config-provider
    :locale="locale"
    prefix-cls="antmain"
  >
    <div
      slot="renderEmpty"
      className="d-flex column align-center"
    >
      <img
        alt="暂无数据"
        width="106"
        height="88"
        :src="theme === THEMES.DARK ? 'http://hh-oss-picture.miyapay.com/box/82e2db719fef5ad8f7c33f20531be9e0.png' : 'http://hh-oss-picture.miyapay.com/box/bffce08d216fbaaaed24337e587b2eff.png'"
      >
      <div
        style="color: rgba(255,255,255,0.85); font-weight:500; margin-top:8px;"
      >暂无数据</div>
    </div>
    <div class="app">
      <router-view />
      <Loading :loading="!!loading" />
      <div
        v-if="false && $route.path !== '/login' && $route.path !== '/create_user'"
        class="questionnaire"
        :class="{'questionnaire--closed': isQuestionnaireClosed}"
      >
        <div
          class="d-flex justify-center align-center arrow"
          @click="openQuestionnaire"
          v-if="isQuestionnaireClosed"
        >
          <img
            width="12"
            height="13"
            src="http://hh-oss-picture.miyapay.com/box/3f9f17f6847fdf9b80131f4bc92435be.png"
          >
        </div>
        <div
          class="closed"
          @click="closeQuestionnaire"
        >关闭</div>
        <img
          style="width: 107px; height: 108px;"
          src="http://hh-oss-picture.miyapay.com/box/fd8c89037c35782f52d2d98f0e9e8465.png"
        >
        <div
          class="questionnaire__text"
          style="margin-top: 5px"
        >为了更好服务客户诚邀您做一份问卷</div>
        <div
          class="questionnaire__text"
          style="color: var(--main-color); cursor: pointer"
          @click="goToQuestionnaire"
        >立即回答</div>
      </div>
      <!-- <Chatbot /> -->
      <ContractModal />
    </div>
  </a-config-provider>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import Loading from '@/components/loading';
// import Chatbot from '@/components/Chatbot';
import ContractModal from '@/components/ContractModal';
import {
  THEMES,
} from '@/consts';

const initialState = {
  theme: localStorage.getItem('theme') || THEMES.LIGHT,
};

export default {
  components: {
    Loading,
    // Chatbot,
    ContractModal,
  },
  data() {
    return {
      locale: zhCN,
      theme: initialState.theme,
      THEMES,
      isQuestionnaireClosed: localStorage.getItem('isQuestionnaireClosed') === 'true',
      maxChangedTime: 0,
      intervalListen: null,
      timeoutLength: 30 * 60 * 1000, // 为方便测试，先改成10min
    };
  },
  created() {
    this.maxChangedTime = new Date().getTime();
    // 设置30分钟内页面没操作，退出登陆 - mouseover监听
    document.addEventListener('mouseover', () => {
      this.maxChangedTime = new Date().getTime();
    });
  },
  computed: {
    ...mapState(['error', 'loading']),
    ...mapState('user', ['userInfo']),
  },
  watch: {
    error(newError) {
      if (newError) {
        this.$message.error(newError.message);
      }
    },
    userInfo(newVal) {
      if (newVal) {
        this.initInterval();
      }
    },
  },
  methods: {
    ...mapActions('user', ['logout']),
    initInterval() {
      const { timeoutLength } = this;
      clearInterval(this.intervalListen);
      this.intervalListen = null;
      this.intervalListen = setInterval(() => {
        console.log(new Date().getTime(), this.maxChangedTime);
        if (new Date().getTime() - this.maxChangedTime > timeoutLength) {
          clearInterval(this.intervalListen);
          this.intervalListen = null;
          this.$message.info('您已经长时间没有操作，系统已自动退出登录');
          this.logout();
        }
      }, 5000);
    },
    goToQuestionnaire() {
      window.open('https://www.wenjuan.com/s/ymqMRjh/#');
    },
    openQuestionnaire() {
      this.isQuestionnaireClosed = false;
      localStorage.setItem('isQuestionnaireClosed', false);
    },
    closeQuestionnaire() {
      this.isQuestionnaireClosed = true;
      localStorage.setItem('isQuestionnaireClosed', true);
    },
    
  },
};
</script>
<style lang="scss" scoped>
.app {
  height: 100%;
}
.questionnaire {
  display: none;
  position: fixed;
  right: 29px;
  bottom: 33px;
  width: 140px;
  height: 200px;
  background: #FFFFFF;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  padding: 23px 17px;
  transition: all .2s linear;

  .closed {
    font-size: 9px;
    font-weight: 300;
    position: absolute;
    right: 4px;
    top: 4px;
    color: #999;
    cursor: pointer;
  }

  .arrow {
    position: absolute;
    width: 20px;
    height: 50px;
    left: -20px;
    top: 50%;
    transform: translateY(-50%);
    background: #fff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  &__text {
    font-size: 12px;
    text-align: center;
  }

  &--closed {
    transform: translateX(170px);
  }
}
</style>
